import {h, Fragment} from "preact"
import { useFacet } from '@nosto/preact';
import Checkbox from './elements/Checkbox';
import Icon from './elements/Icon';
import { ArrowIcon } from './elements/Icons';

export default function FacetCustomized({ facet, setActive, isActive }) {
  const { active, selectedFiltersCount, toggleActive, toggleProductFilter } =
    useFacet(facet);

  return (
    <li
      class={`facets--details ns-sidebar-dropdown ns-flex-fill ns-relative ${
        isActive ? 'ns-active' : ''
      }  `}
    >
      <a
        class="gc_ft_title ns-relative ns-w-100 ns-border-box ns-text-undecorated "
        href="javascript:void(0)"
        data-nosto-element="facet"
        onClick={() => setActive(!isActive)}
      >
        <span class="gc_facet--title">{facet.name}</span>
        {/* {selectedFiltersCount > 0 && (
          <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
            {selectedFiltersCount}
          </span>
        )} */}
        {/* <Icon
          name="arrow"
          className="ns-absolute"
        /> */}
        <ArrowIcon active={isActive} />
      </a>
      <div class="ns-sidebar-submenu ns-d-none facets-wrapper">
        <ul class="ns-list-unstyled ns-p-0 ns-m-0 nsc-facets-list">
          {facet.data?.map((value) => (
            <li
              class="ns-d-flex ns-justify-content-between ns-align-items-center"
              data-nosto-element="facet-setting"
            >
              <Checkbox
                value={value.value}
                selected={value.selected}
                onChange={(e) => {
                  e.preventDefault();
                  toggleProductFilter(
                    facet.field,
                    value.value,
                    !value.selected
                  );
                }}
              />
              <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-border-radius-3">
                ({value.count})
              </span>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
}
